'use strict';

wbApp.controller('ActivityInstructorDetailCtrl', ['$scope', 'activityInstructorSvc',
function ($scope, activityInstructorSvc) {

    $scope.employeeDetailModel = { days: [], onDataSourceChange: function () { }, applyChanges: function () { }};
    $scope.instructorsOrig = [];


    function reloadData(instructors, schedules, employeeID, activityID) {
        // todo: Check changes

        var model = activityInstructorSvc.createEmployeeDetailModel(instructors, schedules, employeeID, activityID);
        $scope.instructorsOrig = angular.copy(instructors);
        $scope.employeeDetailModel = model;
    }

    $scope.onEmployeeChange = function (employeeID) {
        activityInstructorSvc.getAllByEmployeeAndActivity(
            employeeID, $scope.instructorDetailModel.activityID)
        .$promise
        .then(function (instructors) {
            reloadData(instructors, $scope.instructorDetailModel.selection, employeeID, $scope.instructorDetailModel.activityID);
        }); 
    }

    $scope.onWeekSelectionChange = function (selection) {
        $scope.employeeDetailModel.applyChanges.call($scope.employeeDetailModel);
        $scope.employeeDetailModel.onDataSourceChange.call($scope.employeeDetailModel);
    }

    $scope.saveActivityInstructorDetailChanges = function () {
        $scope.employeeDetailModel.applyChanges.call($scope.employeeDetailModel);
        if (!angular.equals($scope.employeeDetailModel.instructors, $scope.instructorsOrig)) {
            activityInstructorSvc.saveAsync(
                $scope.employeeDetailModel.instructors,
                $scope.instructorDetailModel.employeeID,
                $scope.instructorDetailModel.activityID)
            .then(function (data) {
                $scope.onActivityInstructorSave(data);
            }, function (reason) {
                $scope.activityInstructorDetailError = reason;
            });

        }
    }

    if (!$scope.instructorDetailModel.isNew) {
        $scope.onEmployeeChange($scope.instructorDetailModel.employeeID);
    }

}]);